<script>
import { useAlert } from 'dashboard/composables';
import CustomSlaForm from './CustomSlaForm.vue';

export default {
  components: {
    CustomSlaForm,
  },
  emits: ['close'],
  methods: {
    onClose() {
      this.$emit('close');
    },
    async addCustomSla(payload) {
      try {
        await this.$store.dispatch('customSla/create', payload);
        useAlert(this.$t('CUSTOM_SLA.ADD.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        const errorMessage =
          error.message || this.$t('CUSTOM_SLA.ADD.API.ERROR_MESSAGE');
        useAlert(errorMessage);
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="$t('CUSTOM_SLA.ADD.TITLE')"
      :header-content="$t('CUSTOM_SLA.ADD.DESC')"
    />
    <CustomSlaForm
      :submit-label="$t('CUSTOM_SLA.FORM.CREATE')"
      @submit-custom-sla="addCustomSla"
      @close="onClose"
    />
  </div>
</template>
